import screen from './Edit';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Segmentos/Edit/index.js